// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

const CreditPregrantedLimitVariationFailure = () => {
    const goBackButton = {
        label: <FormattedText value="creditPregrantedLimitVariationFailure-goBackButton" format="uppercase" />,
        url: '/myprofile/loans-mortgages'
    };
    const errorMessage = formatText('creditPregrantedLimitVariationFailure-errorMessage');
    const errorSubMessage = <FormattedText value="creditPregrantedLimitVariationFailure-errorSubMessage" />

    return (
        <article className="credit-pregranted-limit-variation-failure  row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError errorMessage={errorMessage} mainButton={goBackButton} errorSubMessage={errorSubMessage} />
            </div>
        </article>
    );
};

module.exports = CreditPregrantedLimitVariationFailure;
